import defaultSettings from '@/settings'
import { useDynamicTitle } from '@/utils/dynamicTitle'
import { getTheme, updateTheme } from '@/api/theme'
import { applyTheme, cacheTheme, getCachedTheme, normalizeTheme } from '@/utils/theme'

const { sideTheme, showSettings, topNav, tagsView, tagsIcon, fixedHeader, sidebarLogo, dynamicTitle, footerVisible, footerContent } = defaultSettings

const cachedTheme = getCachedTheme()
const layoutSetting = JSON.parse(localStorage.getItem('layout-setting')) || {}
applyTheme(cachedTheme)

const state = {
  title: '',
  theme: cachedTheme.primaryColor,
  themeConfig: cachedTheme,
  sideTheme: cachedTheme.sideTheme || sideTheme,
  showSettings: showSettings,
  topNav: layoutSetting.topNav === undefined ? topNav : layoutSetting.topNav,
  tagsView: layoutSetting.tagsView === undefined ? tagsView : layoutSetting.tagsView,
  tagsIcon: layoutSetting.tagsIcon === undefined ? tagsIcon : layoutSetting.tagsIcon,
  fixedHeader: layoutSetting.fixedHeader === undefined ? fixedHeader : layoutSetting.fixedHeader,
  sidebarLogo: layoutSetting.sidebarLogo === undefined ? sidebarLogo : layoutSetting.sidebarLogo,
  dynamicTitle: layoutSetting.dynamicTitle === undefined ? dynamicTitle : layoutSetting.dynamicTitle,
  footerVisible: layoutSetting.footerVisible === undefined ? footerVisible : layoutSetting.footerVisible,
  footerContent: footerContent
}
const mutations = {
  CHANGE_SETTING: (state, { key, value }) => {
    if (state.hasOwnProperty(key)) {
      state[key] = value
    }
  },
  SET_THEME_CONFIG: (state, themeConfig) => {
    const normalizedTheme = normalizeTheme(themeConfig)
    state.themeConfig = normalizedTheme
    state.theme = normalizedTheme.primaryColor
    state.sideTheme = normalizedTheme.sideTheme
  }
}

const actions = {
  // 修改布局设置
  changeSetting({ commit }, data) {
    commit('CHANGE_SETTING', data)
    if (data.key === 'theme') {
      const themeConfig = cacheTheme({ primaryColor: data.value, sideTheme: state.sideTheme })
      applyTheme(themeConfig)
      commit('SET_THEME_CONFIG', themeConfig)
    }
    if (data.key === 'sideTheme') {
      const themeConfig = cacheTheme({ primaryColor: state.theme, sideTheme: data.value })
      applyTheme(themeConfig)
      commit('SET_THEME_CONFIG', themeConfig)
    }
  },
  loadTheme({ commit }) {
    applyTheme(state.themeConfig)
    return getTheme().then(response => {
      const themeConfig = cacheTheme(response.data)
      applyTheme(themeConfig)
      commit('SET_THEME_CONFIG', themeConfig)
      return themeConfig
    }).catch(() => state.themeConfig)
  },
  saveTheme({ commit }, theme) {
    const themeConfig = normalizeTheme(theme)
    return updateTheme(themeConfig).then(response => {
      const savedTheme = cacheTheme(response.data || themeConfig)
      applyTheme(savedTheme)
      commit('SET_THEME_CONFIG', savedTheme)
      return savedTheme
    })
  },
  previewTheme({ commit }, theme) {
    const themeConfig = normalizeTheme(theme)
    applyTheme(themeConfig)
    commit('SET_THEME_CONFIG', themeConfig)
  },
  // 设置网页标题
  setTitle({ commit }, title) {
    state.title = title
    useDynamicTitle()
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

